/**
 * A cor principal do escritório nos tokens do design (Configuracoes.dc.html,
 * "Cor principal"). O tom é ajustado para manter a leitura: texto sobre a cor com
 * pelo menos 4,5:1 e, no tema escuro, a cor com pelo menos 3:1 sobre a superfície.
 * O marinho do EGORA (ou nenhuma cor) devolve null: valem os tokens do design.
 */
export const COR_PADRAO = '#0E2036';
export const VARIAVEIS = ['--accent', '--accent-hover', '--on-accent', '--accent-text', '--accent-soft', '--accent-soft-ink', '--focus-ring'];

export function hexValido(h) {
  return /^#[0-9a-fA-F]{6}$/.test(String(h || '').trim());
}

function rgb(h) {
  const v = String(h).trim().replace('#', '');
  return [0, 2, 4].map((i) => parseInt(v.slice(i, i + 2), 16));
}
const hex = (c) => `#${c.map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0')).join('')}`.toUpperCase();
function luminancia(c) {
  const l = c.map((v) => { const x = v / 255; return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4; });
  return 0.2126 * l[0] + 0.7152 * l[1] + 0.0722 * l[2];
}
export function contraste(a, b) {
  const x = luminancia(a); const y = luminancia(b);
  return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
}
const misturar = (a, b, t) => a.map((v, i) => v + (b[i] - v) * t);
function garantir(cor, fundo, alvo) {
  if (contraste(cor, fundo) >= alvo) return cor;
  const para = luminancia(fundo) > 0.3 ? [0, 0, 0] : [255, 255, 255];
  for (let i = 1; i <= 20; i += 1) {
    const c = misturar(cor, para, i / 20);
    if (contraste(c, fundo) >= alvo) return c;
  }
  return para;
}

/** Os valores dos tokens para a cor e o tema, com o contraste e se o tom foi ajustado. */
export function coresDoEscritorio(cor, escuro) {
  if (!hexValido(cor) || cor.toUpperCase() === COR_PADRAO) return null;
  const base = rgb(cor);
  const superficie = escuro ? [17, 27, 43] : [255, 255, 255];
  const branco = [255, 255, 255]; const tinta = [15, 31, 29];
  let fundo = escuro ? garantir(base, superficie, 3) : base;
  const sobre = contraste(branco, fundo) >= contraste(tinta, fundo) ? branco : tinta;
  if (contraste(sobre, fundo) < 4.5) fundo = garantir(fundo, sobre, 4.5);
  const texto = garantir(base, superficie, 4.5);
  const suave = misturar(superficie, base, escuro ? 0.22 : 0.1);
  return {
    '--accent': hex(fundo),
    '--accent-hover': hex(escuro ? misturar(fundo, branco, 0.15) : misturar(fundo, [0, 0, 0], 0.15)),
    '--on-accent': hex(sobre),
    '--accent-text': hex(texto),
    '--accent-soft': hex(suave),
    '--accent-soft-ink': hex(garantir(base, suave, 4.5)),
    '--focus-ring': hex(texto),
    contraste: Math.round(contraste(sobre, fundo) * 10) / 10,
    ajustada: hex(fundo) !== hex(base),
  };
}
